// Module
var code = "<abx-building abx-model=\"vm.model\" abx-on-change=\"vm.handleChange($event)\" abx-disabled=\"vm.disabled || vm.state === $root.COMPONENT_STATE.saving\" abx-on-focus=\"vm.handleFocus()\" abx-on-select=\"vm.handleSelect($event)\" abx-on-blur=\"vm.handleBlur({ model: vm.model })\" abx-value=\"vm.value\"> </abx-building> ";
// Exports
module.exports = code;